// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phone-input {
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #999999;
}

.phone-input:focus {
  border-color: #FF0009;
  outline: unset;
}
`, "",{"version":3,"sources":["webpack://./src/components/input/PhoneInput.scss","webpack://./src/components/input/PhoneInput.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;ACC3B;;ADJA;EAKI,qBAAqB;EACrB,cAAc;ACGlB","sourcesContent":[".phone-input {\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #999999;\n  &:focus {\n    border-color: #FF0009;\n    outline: unset;\n  }\n}",".phone-input {\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #999999;\n}\n\n.phone-input:focus {\n  border-color: #FF0009;\n  outline: unset;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
